import React from 'react';
import { CasePlanSection } from '@orijinworks/frontend-commons';
import { buildSectionFooterActionProps } from '../../../../utils/case-plan-section.util';
import { useEditableCasePlanSectionHook } from './useEditableCasePlanSectionHook';

/**
 * One section rendered with every editing control the staff member is allowed to use.
 * Read-only renders (preview, archived plan, Archived tab) use `CasePlanSection` directly so
 * no callback reaches it.
 */
export function EditableCasePlanSection({
  section,
  collapsed,
  onToggleCollapse,
  onAddWidget,
  onWidgetDescriptionBlur,
  moveUpDisabled,
  moveDownDisabled,
  titleAutoFocus = false,
  destructiveAction,
  onTitleSave,
  onDescriptionSave,
  onVisibilityChange,
  onMove,
  onRemove,
}) {
  const {
    title,
    description,
    onTitleChange,
    onTitleBlur,
    onDescriptionChange,
    onDescriptionBlur,
    onVisibleToLearnerChange,
    onMoveUp,
    onMoveDown,
    onRemove: handleRemove,
  } = useEditableCasePlanSectionHook({
    section,
    onTitleSave,
    onDescriptionSave,
    onVisibilityChange,
    onMove,
    onRemove,
  });

  return (
    <CasePlanSection
      title={title}
      titleEditable
      titleAutoFocus={titleAutoFocus}
      onTitleChange={onTitleChange}
      onTitleBlur={onTitleBlur}
      description={description}
      onDescriptionChange={onDescriptionChange}
      onDescriptionBlur={onDescriptionBlur}
      visibleToLearner={section.visibleToLearner}
      onVisibleToLearnerChange={onVisibleToLearnerChange}
      widgets={section.widgets}
      collapsed={collapsed}
      onToggleCollapse={onToggleCollapse}
      onMoveUp={onMoveUp}
      onMoveDown={onMoveDown}
      moveUpDisabled={moveUpDisabled}
      moveDownDisabled={moveDownDisabled}
      onAddWidget={onAddWidget}
      onWidgetDescriptionBlur={onWidgetDescriptionBlur}
      onEmptyStateButtonClick={onAddWidget}
      {...buildSectionFooterActionProps(destructiveAction, handleRemove)}
    />
  );
}
